import React from 'react';
import { Gql } from '@fiverr-private/loyalty_utils';
import { LoyaltyGoldIcon, LoyaltyPlatinumIcon, LoyaltySilverIcon } from '../../../icons';

interface LoyaltyTierIconProps {
    tier: Gql.LoyaltyProgramTier;
    size?: 'sm' | 'md' | 'lg' | { width: number; height: number };
}

const sizesTable = {
    sm: { width: 14, height: 16 },
    md: { width: 22, height: 24 },
    lg: { width: 36, height: 40 },
};

/**
 * @deprecated This component is deprecated. Use `LoyaltyTierIcon` instead.
 */
export const OldLoyaltyTierIcon = ({ tier, size = 'md' }: LoyaltyTierIconProps) => {
    const sizes = sizesTable[size.toString()] || size;

    switch (tier) {
        case Gql.LoyaltyProgramTier.Silver:
            return <LoyaltySilverIcon {...sizes} />;
        case Gql.LoyaltyProgramTier.Gold:
            return <LoyaltyGoldIcon {...sizes} />;
        case Gql.LoyaltyProgramTier.Platinum:
            return <LoyaltyPlatinumIcon {...sizes} />;
        default:
            return null;
    }
};
